__turbopack_context__.v({
  "comingSoonTitle": "nft-assets-module__MdPlOq__comingSoonTitle",
  "comingSoonWalletWrapper": "nft-assets-module__MdPlOq__comingSoonWalletWrapper",
  "content": "nft-assets-module__MdPlOq__content",
  "iconWallet": "nft-assets-module__MdPlOq__iconWallet",
  "listNfts": "nft-assets-module__MdPlOq__listNfts",
  "loading": "nft-assets-module__MdPlOq__loading",
  "logoutWallet": "nft-assets-module__MdPlOq__logoutWallet",
  "root": "nft-assets-module__MdPlOq__root",
  "title": "nft-assets-module__MdPlOq__title",
  "titleWallet": "nft-assets-module__MdPlOq__titleWallet",
  "walletImage": "nft-assets-module__MdPlOq__walletImage",
  "walletPreview": "nft-assets-module__MdPlOq__walletPreview",
  "walletWrapper": "nft-assets-module__MdPlOq__walletWrapper",
  "walletWrapperLoggedIn": "nft-assets-module__MdPlOq__walletWrapperLoggedIn",
  "wrapperLogin": "nft-assets-module__MdPlOq__wrapperLogin",
});
